import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalPopUp } from './modal-popup';
import { AuthService } from '../../services/auth.service';
import { DataService } from '../../services/Data.service';
import { Router } from '@angular/router';

@Injectable()
export class ModalPopupService {
  modelRef: NgbModalRef;
  isChangeDetected = false;
  logOut = false;
  test = false;

  constructor(
    private modalService: NgbModal,
    private dataService:DataService, 
    private authService: AuthService, 
    private router: Router
  ) { }

  openModal() {
    this.test = true;
    this.modelRef = this.modalService.open(ModalPopUp, { centered: true, backdrop:'static' })
  }

  stayOnPage() {
    this.test = false;
    this.logOut = false;
    return this.modelRef.close(false)
  }

  leavePage() {
    this.test = false;
    setTimeout(()=>{
      if(this.logOut === true){
        this.isChangeDetected = false;
        this.modelRef.close(true);
        setTimeout(()=>{
          this.dataService.sharedDataMap = new Map<string, any>();
          this.authService.signOut();
          this.router.navigate(['SNAPWorks/providerportal']);
        },0);
        this.logOut = false;
      }
      else{
        this.setChangeDetected(false);
        return this.modelRef.close(true);
      }
    },0);
    
  }

  getResult() {
    return this.modelRef.result;
  }

  setChangeDetected(result: boolean) {
    this.isChangeDetected = result;
  }

  getChangeDetected() {
    return this.isChangeDetected;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-popup/modal-popup.service.ts